<template>
  <div class="flex items-center">
    <div class="box border mr-6 flex-no-shrink overflow-hidden"> <!-- Preview -->
      <video
        v-if="hasType('video')"
        width="160"
        height="90"
        loop
        @mouseenter="$event.target.play()"
        @mouseleave="$event.target.currentTime = 0; $event.target.pause();"
      >
        <source :src="selectedOption.path" type="video/mp4" />
      </video>
      <div
        v-if="hasType('image')"
        class="box bg-cover"
        :style="{
          backgroundImage: `url(${ selectedOption.path })`
        }"
      >
      </div>
      <div v-else class="box h-full flex justify-center items-center text-xs text-grey">
        No Preview Available
      </div>
    </div>
    <div class="w-full flex flex-col">
      <label class="mb-2 uppercase text-xs font-bold">{{ presetName }}</label>
      <pl-select
        selectClass="p-2 border-gray-light bg-white shadow rounded pr-8"
        class="w-full"
        v-model="selectedOption"
        :disabled="disabled"
      >
        <option :value="null">Select an option</option>
        <option
          v-for="(option, index) in options"
          :key="index"
          :value="option"
        >{{ option.title }}</option>
      </pl-select>
      <div class="block mt-2 text-xs text-grey" v-if="helptext" v-html="helptext"></div>
    </div>
  </div>
</template>

<style scoped>
.box {
  width: 160px;
  height: 90px;
}
</style>

<script>
export default {
  name: 'QuickPresetSelector',

  props: ['value', 'presetName', 'options', 'helptext', 'disabled'],

  computed: {
    selectedOption: {
      get () {
        return this.value
      },

      set (val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    hasType (type) {
      if (!this.selectedOption) {
        return false
      }

      if (type === 'video') {
        return /mp4|webm|mov/.test(this.selectedOption.path)
      } else if (type === 'image') {
        return /jpe?g|png|gif/.test(this.selectedOption.path)
      }
    }
  },

  watch: {
    selectedOption (newVal, oldVal) {
      if (this.hasType('video') && newVal.path !== oldVal.path) {
        this.$el.querySelector('video').load()
      }
    }
  }
}
</script>
